import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "loader"]

  show() {
    const file = this.inputTarget.files[0]

    if (file) {
      this.previewTarget.classList.add("d-none")
      this.loaderTarget.classList.remove("d-none")

      const reader = new FileReader()

      reader.onload = (e) => {
        this.previewTarget.src = e.target.result
        this.loaderTarget.classList.add("d-none")
        this.previewTarget.classList.remove("d-none")
      }
      reader.readAsDataURL(file)
    }
  }
}
